import {
    HISTORY_READ,
    INVOICE_READ,
    PAYMENT_INFORMATION_WRITE,
    SUBSCRIPTION_READ,
    SUBSCRIPTION_WRITE,
} from '../common/permissions/permissions';
import { Tenant } from '../common/utils/tenants';
import { CustomerCenterTab, type TabInfo } from './types';

const freeTrial: TabInfo = {
    componentName: CustomerCenterTab.FREE_TRIAL,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [SUBSCRIPTION_READ],
    labelId: 'intl-msg:marketplace.free.trial',
};

const services: TabInfo = {
    componentName: CustomerCenterTab.SERVICES,
    limitedToTenants: [Tenant.EU, Tenant.SOUTH_KOREA, Tenant.SOUTH_AFRICA],
    requiredPermissions: [SUBSCRIPTION_READ],
    labelId: 'intl-msg:marketplace.myServices',
};

const bookings: TabInfo = {
    componentName: CustomerCenterTab.BOOKINGS,
    limitedToTenants: [Tenant.EU, Tenant.SOUTH_KOREA, Tenant.SOUTH_AFRICA],
    requiredPermissions: [],
    labelId: 'intl-msg:marketplace.bookings',
};

const bookingsOverview: TabInfo = {
    componentName: CustomerCenterTab.BOOKINGS_OVERVIEW,
    limitedToTenants: [Tenant.EU, Tenant.SOUTH_KOREA, Tenant.SOUTH_AFRICA],
    requiredPermissions: [SUBSCRIPTION_READ],
    labelId: 'intl-msg:marketplace.bookings.overview',
};

const assets: TabInfo = {
    componentName: CustomerCenterTab.ASSETS,
    limitedToTenants: [Tenant.EU, Tenant.SOUTH_KOREA, Tenant.SOUTH_AFRICA],
    requiredPermissions: [SUBSCRIPTION_READ],
    labelId: 'intl-msg:marketplace.preview.multilevel.vehicles',
};

const contracts: TabInfo = {
    componentName: CustomerCenterTab.CONTRACTS,
    limitedToTenants: [Tenant.EU, Tenant.SOUTH_AFRICA],
    requiredPermissions: [SUBSCRIPTION_READ],
    labelId: 'intl-msg:marketplace.contracts',
};

const invoices: TabInfo = {
    componentName: CustomerCenterTab.INVOICES,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [INVOICE_READ],
    labelId: 'intl-msg:marketplace.invoices',
};

const usage: TabInfo = {
    componentName: CustomerCenterTab.USAGE,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [INVOICE_READ],
    labelId: 'intl-msg:marketplace.usage',
};

const history: TabInfo = {
    componentName: CustomerCenterTab.HISTORY,
    limitedToTenants: [Tenant.EU, Tenant.SOUTH_KOREA, Tenant.SOUTH_AFRICA],
    requiredPermissions: [HISTORY_READ],
    labelId: 'intl-msg:marketplace.history',
};

const paymentMethods: TabInfo = {
    componentName: CustomerCenterTab.PAYMENT_METHODS,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [PAYMENT_INFORMATION_WRITE],
    labelId: 'intl-msg:marketplace.payment.method',
};

const billing: TabInfo = {
    componentName: CustomerCenterTab.BILLING,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [],
    labelId: 'intl-msg:marketplace.billing',
};

const billingInvoices: TabInfo = {
    componentName: CustomerCenterTab.BILLING_INVOICES,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [INVOICE_READ],
    labelId: 'intl-msg:marketplace.invoices',
};

const billingUsage: TabInfo = {
    componentName: CustomerCenterTab.BILLING_USAGE,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [INVOICE_READ],
    labelId: 'intl-msg:marketplace.usage',
};

const billingPaymentMethod: TabInfo = {
    componentName: CustomerCenterTab.BILLING_PAYMENT_METHOD,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [PAYMENT_INFORMATION_WRITE],
    labelId: 'intl-msg:marketplace.payment.method',
};

const partnerConnections: TabInfo = {
    componentName: CustomerCenterTab.PARTNERS,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [SUBSCRIPTION_WRITE],
    labelId: 'intl-msg:marketplace.partners',
};

const inboundConnections: TabInfo = {
    componentName: CustomerCenterTab.INBOUND,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [SUBSCRIPTION_WRITE],
    labelId: 'intl-msg:marketplace.connections.inbound',
};

const outboundConnections: TabInfo = {
    componentName: CustomerCenterTab.OUTBOUND,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [SUBSCRIPTION_WRITE],
    labelId: 'intl-msg:marketplace.connections.outbound',
};

const companySettings: TabInfo = {
    componentName: CustomerCenterTab.COMPANY_SETTINGS,
    limitedToTenants: [Tenant.EU],
    requiredPermissions: [SUBSCRIPTION_WRITE],
    labelId: 'intl-msg:marketplace.company.settings',
};

export const getCustomerCenterTabs = (): TabInfo[] => [
    bookings,
    freeTrial,
    services,
    assets,
    contracts,
    billing,
    billingInvoices,
    billingUsage,
    billingPaymentMethod,
    history,
    bookingsOverview,
    partnerConnections,
    inboundConnections,
    outboundConnections,
    companySettings,
];
